<template>
  <div
    class="slide-confirm"
    :class="[`is-${tone}`, { disabled }]"
  >
    <span>{{ $t(progress >= threshold ? readyText : label) }}</span>
    <div
      ref="handle"
      class="slide-confirm-handle"
      :class="{ dragging }"
      :style="{ transform: `translateX(${offset}px)` }"
      @pointerdown.stop.prevent="startSlide"
      @pointermove.stop.prevent="moveSlide"
      @pointerup.stop.prevent="endSlide"
      @pointercancel.stop.prevent="cancelSlide"
    ><i :class="iconClass"></i></div>
  </div>
</template>

<script>
export default {
  name: 'GroundStationSlideConfirm',
  props: {
    label: { type: String, default: '向右滑动' },
    readyText: { type: String, default: '松开确认' },
    iconClass: { type: String, default: 'el-icon-right' },
    tone: { type: String, default: 'danger' },
    disabled: { type: Boolean, default: false },
    threshold: { type: Number, default: 85 }
  },
  data () {
    return {
      dragging: false,
      offset: 0,
      progress: 0,
      startX: 0,
      startOffset: 0,
      maxOffset: 0
    }
  },
  watch: {
    disabled () { this.reset() }
  },
  methods: {
    startSlide (event) {
      if (this.disabled) return
      const track = this.$el
      const handle = this.$refs.handle
      if (!track || !handle) return
      this.maxOffset = Math.max(0, track.clientWidth - handle.clientWidth - 4)
      this.startX = event.clientX
      this.startOffset = this.offset
      this.dragging = true
      this.$emit('interaction-start')
      if (event.currentTarget.setPointerCapture) event.currentTarget.setPointerCapture(event.pointerId)
    },
    moveSlide (event) {
      if (!this.dragging) return
      this.offset = Math.min(this.maxOffset, Math.max(0, this.startOffset + event.clientX - this.startX))
      this.progress = this.maxOffset > 0 ? Math.round(this.offset / this.maxOffset * 100) : 0
    },
    endSlide () {
      if (!this.dragging) return
      this.dragging = false
      this.$emit('interaction-end')
      if (this.progress >= this.threshold) this.$emit('confirm')
      this.reset()
    },
    cancelSlide () {
      if (!this.dragging) return
      this.reset()
      this.$emit('interaction-end')
    },
    reset () {
      this.dragging = false
      this.offset = 0
      this.progress = 0
      this.startX = 0
      this.startOffset = 0
      this.maxOffset = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-confirm {
  height: 36px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--ui-text-muted);
  border-radius: 4px;
  background: var(--ui-bg-canvas);
  font-size: var(--gs-font-caption, 11px);
  user-select: none;
}

.slide-confirm.disabled {
  opacity: .35;
}

.slide-confirm-handle {
  width: 34px;
  height: 32px;
  position: absolute;
  top: 2px;
  left: 2px;
  display: grid;
  place-items: center;
  color: var(--ui-color-white);
  border-radius: 3px;
  background: var(--ui-color-danger-active);
  cursor: grab;
  touch-action: none;
}

.slide-confirm-handle.dragging {
  cursor: grabbing;
}

.slide-confirm.disabled .slide-confirm-handle {
  cursor: not-allowed;
}

.slide-confirm.is-danger {
  box-shadow: inset 0 0 0 1px rgba(var(--ui-color-danger-emphasis-rgb), .18);
}
</style>
